import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classes from './CoachHeaderInfo.module.scss'
import Avatar from '../common/avatar/deprecated/Avatar'
import CommunityAvatar from '../common/avatar/CommunityAvatar'
import { ReactComponent as AnnouncementIcon } from '../../assets/images/common/icons/announcement-icon.svg'

const CoachHeaderInfo = ({ coach, community }) => {
  const { t } = useTranslation()

  return (
    <div className={classes.container}>
      <div className={classes.coachAvatarContainer}>
        <Avatar
          className='img-responsive'
          imageUrl={coach?.avatar?.file_url}
          hasCoachLabel
          hasBorder
          altName={coach?.first_name + ' ' + coach?.last_name}
        />

        <div className={classes.profileInfoContainer}>
          <div className={classes.coachNameContainer}>
            <h5 className={classes.coachName}>
              {coach?.first_name} {coach?.last_name}
            </h5>
            <div className={classes.coachPill}>
              {t('activity.common.coach')}
            </div>
          </div>
          {community && (
            <div className='d-flex align-items-center mt-1'>
              <CommunityAvatar community={community} className='mr-2' />
              <p className={`${classes.communityName} mb-0`}>{community.name}</p>
            </div>
          )}
          <div className={classes.coachTitle}>
            {t('activity.coachHeader.coachAnnouncement')}
          </div>
        </div>
      </div>
      <div className={classes.announcementIcon}>
        <AnnouncementIcon className={classes.icon}/>
      </div>
    </div>
  )
}

CoachHeaderInfo.propTypes = {
  coach: PropTypes.object.isRequired,
  community: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    photo: PropTypes.object,
  }),
}

export default CoachHeaderInfo
